import classNames from 'classnames';
import { bool, object } from 'prop-types';
import { func } from 'prop-types';
import { string } from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING,
  TRANSITION_EXTEND_DISPUTE,
  TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
  TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY,
  TRANSITION_EXTEND_PAYOUT_ADDITION_FEE,
  TRANSITION_EXTEND_REQUEST_PAYMENT_FREE,
} from '../../util/customTransaction/extendRentalTransaction';
import {
  TRANSITION_DECLINE_EXTEND_BOOKING,
  TRANSITION_DISPUTE,
  TRANSITION_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING,
  TRANSITION_OFFER_EXTEND_BOOKING_DIRECTLY,
  TRANSITION_TRANSFERRED,
} from '../../util/customTransaction/mainRentalTransaction';
import Button, { SecondaryButton } from '../Button/Button';
import Modal from '../Modal/Modal';
import css from './ConfirmDisputeModal.module.css';

const getNextTransitionForDispute = lastTransition => {
  switch (lastTransition) {
    // main rental
    case TRANSITION_TRANSFERRED:
      return TRANSITION_DISPUTE;

    case TRANSITION_OFFER_EXTEND_BOOKING_DIRECTLY:
    case TRANSITION_DECLINE_EXTEND_BOOKING:
      return TRANSITION_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING;

    // extend rental
    case TRANSITION_EXTEND_PAYOUT_ADDITION_FEE:
    case TRANSITION_EXTEND_REQUEST_PAYMENT_FREE:
      return TRANSITION_EXTEND_DISPUTE;

    case TRANSITION_EXTEND_OFFER_EXTEND_BOOKING_DIRECTLY:
    case TRANSITION_EXTEND_DECLINE_EXTEND_BOOKING:
      return TRANSITION_EXTEND_DISPUTE_AFTER_OFFERED_EXTEND_BOOKING;

    default:
      break;
  }
};

const ConfirmDisputeModal = props => {
  const {
    id,
    className,
    rootClassName,
    isOpen,
    onClose,
    onManageDisableScrolling,
    onDispute,
    disputeInProgress,
    disputeError,
    transaction,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const lastTransition = transaction?.attributes?.lastTransition;
  const transitionName = getNextTransitionForDispute(lastTransition);

  const onConfirmDispute = () => {
    onDispute({ transaction, transitionName });
  };

  const errorMaybe = disputeError ? (
    <p className={css.error}>
      <FormattedMessage id="ConfirmDisputeModal.disputeFailedMessage" />
    </p>
  ) : null;

  return (
    <Modal
      className={classes}
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <h3 className={css.heading}>
        <FormattedMessage id="ConfirmDisputeModal.heading" />
      </h3>

      {errorMaybe}

      <div className={css.buttonsWrapper}>
        <SecondaryButton
          className={css.cancelButton}
          onClick={onClose}
          disabled={disputeInProgress}
        >
          <FormattedMessage id="ConfirmDisputeModal.cancel" />
        </SecondaryButton>
        <Button
          disabled={disputeInProgress}
          inProgress={disputeInProgress}
          onClick={onConfirmDispute}
        >
          <FormattedMessage id="ConfirmDisputeModal.confirm" />
        </Button>
      </div>
    </Modal>
  );
};

ConfirmDisputeModal.defaultProps = {
  id: '',
  className: '',
  rootClassName: '',
  isOpen: false,
  onManageDisableScrolling: null,
  onClose: null,
  onDispute: null,
  disputeInProgress: false,
  disputeError: null,
};

ConfirmDisputeModal.propTypes = {
  id: string.isRequired,
  className: string,
  rootClassName: string,
  isOpen: bool.isRequired,
  onManageDisableScrolling: func.isRequired,
  onClose: func.isRequired,
  onDispute: func.isRequired,
  disputeInProgress: bool.isRequired,
  disputeError: object,
};

export default ConfirmDisputeModal;
